import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import Login from '@/components/Login';
import Frame from '@/components/Frame';
import Home from '@/components/Home';
import Clients from '@/components/Clients';
import Worksheets from '@/components/Worksheets';
import NewClient from '@/components/NewClient';
import EditClient from '@/components/EditClient';
import NewWorksheet from '@/components/NewWorksheet';
import EditWorksheet from '@/components/EditWorksheet';
import AdminPage from '@/components/AdminPage';

Vue.use(Router)

export default new Router({
    mode: 'hash',
    routes: [
        {
            path: '/login',
            name: 'Login',
            component: Login,
            beforeEnter(to, from, next){
                if(store.getters['LoginModul/isLogged']){
                    next({ name: 'Home' });
                } else {
                    next();
                }
            }
        },
        {
            path: '/',
            component: Frame,
            beforeEnter(to, from, next){
                if(store.getters['LoginModul/isLogged']){
                    next();
                } else {
                    next({ name: 'Login' });
                }
            },
            children: [
                {
                    path: '/',
                    redirect: '/menu'
                },
                {
                    path: '/menu',
                    name: 'Home',
                    component: Home
                },
                {
                    path: 'ugyfelek',
                    name: 'Clients',
                    component: Clients
                },
                {
                    path: 'szervizmunkak',
                    name: 'Worksheets',
                    component: Worksheets
                },
                {
                    path: 'uj-ugyfel',
                    name: 'NewClient',
                    component: NewClient
                },
                {
                    path: 'ugyfel/:id',
                    name: 'EditClient',
                    component: EditClient
                },
                {
                    path: 'uj-szervizmunka',
                    name: 'NewWorksheet',
                    component: NewWorksheet
                },
                {
                    path: 'szervizmunka/:id',
                    name: 'EditWorksheet',
                    component: EditWorksheet
                },
                {
                    path: 'admin',
                    name: 'AdminPage',
                    component: AdminPage,
                    beforeEnter(to, from, next){
                        if (store.getters['LoginModul/isAdmin']) {
                            next();
                        } else {
                            next({name: 'Home'});
                        }
                    }
                }
            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js